export default "__VITE_ASSET__D1$64ExT__";